module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-611edb30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DefaultLayout.vue
// module id = 526
// module chunks = 1